import React from 'react';
import { Link } from 'react-router-dom';

function Home() {
    return (
        <div>
            <div className="hero">
                {/* ADDED VIDEO ELEMENT */}
                <video
                    autoPlay
                    loop
                    muted
                    className="hero-video"
                    poster="/background-poster.jpg" /* ADD THIS LINE */
                    playsInline
                    webkit-playsinline="true"
                >
                    <source
                        src="/background.mp4"
                        type="video/mp4"
                    />
                    Your browser does not support the video tag.
                </video>
                {/* END VIDEO ELEMENT */}

                {/* WRAP THE ORIGINAL CONTENT IN hero-content */}
                <div className="hero-content">
                    <h1>Relax. Rejuvenate. Restore.</h1>
                    <p>Experience the best holistic massage therapy in town.</p>
                    <br />
                    <Link to="/services" className="btn" style={{ background: '#D09E88' }}>View Our Menu</Link>
                </div>
                {/* END WRAPPER */}
            </div>
            <div className="container" style={{ textAlign: 'center'}}>
                <h3>Why Choose Us?</h3>
                {/*<video*/}
                {/*    width={'70%'}*/}
                {/*    controls*/}
                {/*>*/}
                {/*    <source*/}
                {/*        src="/promote.mp4"*/}
                {/*        type="video/mp4"*/}
                {/*    />*/}
                {/*    Your browser does not support the video tag.*/}
                {/*</video>*/}
                <p>Experience the difference with only premium, organic, cold-pressed oils chosen for their therapeutic properties.</p>
                <p>Our licensed therapists specialize in clinical deep tissue work, not just surface-level relaxation. Your goals are our focus.</p>
            </div>
        </div>
    );
}

export default Home;